module.exports = __webpack_public_path__ + "img/favicon.b804c144.png";